import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { ExclamationTriangleFill, ArrowUpRight } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';
import './DeleteAccountModal.css';

interface DeleteAccountModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  loading: boolean;
}

const DeleteAccountModal: React.FC<DeleteAccountModalProps> = ({
  show,
  onHide,
  onConfirm,
  loading
}) => {
  const navigate = useNavigate();

  const handleViewPlans = () => {
    onHide();
    navigate('/select-plan');
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="delete-account-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <ExclamationTriangleFill className="warning-icon" />
          <span>Are you sure?</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="description-text">
          Are you sure you would like to delete all your data? This permanent action cannot be undone. Before you continue, please ensure that you download any data from your <strong>Profile & Settings</strong> page that you would like to keep.
        </p>
        <div className="view-plans-row">
          <span className="view-plans-text">Would you like to take a look at your plan options again?</span>
          <Button
            variant="link"
            className="view-plans-link"
            onClick={handleViewPlans}
          >
            VIEW PLANS&nbsp;
            <ArrowUpRight size={16} className="ms-1" />
          </Button>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="link"
          onClick={onHide}
          className="cancel-btn"
          disabled={loading}
        >
          CANCEL
        </Button>
        <Button
          variant="warning"
          onClick={onConfirm}
          className="action-btn"
          disabled={loading}
        >
          {loading ? <Spinner size="sm" /> : 'Delete All Data'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteAccountModal;
